function parseBirthdateToLocalDate(value) {
  const raw = String(value || '').trim();
  if (!raw) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [y, m, d] = raw.split('-').map(Number);
    const dt = new Date(y, m - 1, d);
    if (dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d) return dt;
    return null;
  }

  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(raw);
  if (!match) return null;
  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const dt = new Date(year, month - 1, day);
  if (dt.getFullYear() !== year || dt.getMonth() !== month - 1 || dt.getDate() !== day) return null;
  return dt;
}

function toReferenceDate(referenceDate) {
  if (referenceDate instanceof Date) {
    return new Date(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate());
  }
  return parseBirthdateToLocalDate(referenceDate);
}

export function ageYearsOnDate(birthdate, referenceDate = new Date()) {
  const dob = parseBirthdateToLocalDate(birthdate);
  const ref = toReferenceDate(referenceDate);
  if (!dob || !ref) return null;

  let age = ref.getFullYear() - dob.getFullYear();
  const monthDiff = ref.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && ref.getDate() < dob.getDate())) age -= 1;
  if (age < 0 || age > 130) return null;
  return age;
}

export function formatTrekAgeRangeLabel(minAge, maxAge) {
  const minN = Number(minAge);
  const maxN = Number(maxAge);
  const hasMin = Number.isFinite(minN);
  const hasMax = Number.isFinite(maxN);
  if (!hasMin && !hasMax) return '';
  if (hasMin && hasMax) return `${minN}–${maxN} years`;
  if (hasMin) return `Min ${minN} years`;
  return `Up to ${maxN} years`;
}

/** Calendar bounds for DOB picker — matches validateAgeForTrekRange on departure date. */
export function dobBoundsForTrekAgeRange({ minAge, maxAge, referenceDate } = {}) {
  const ref = toReferenceDate(referenceDate);
  const fallbackMin = new Date(new Date().getFullYear() - 100, 0, 1);
  const fallbackMax = new Date();
  if (!ref) return { minDate: fallbackMin, maxDate: fallbackMax };

  const minN = minAge != null && minAge !== '' ? Number(minAge) : null;
  const maxN = maxAge != null && maxAge !== '' ? Number(maxAge) : null;
  const hasMin = Number.isFinite(minN);
  const hasMax = Number.isFinite(maxN);

  let minDate = fallbackMin;
  let maxDate = fallbackMax;

  if (hasMax) {
    minDate = new Date(ref.getFullYear() - maxN - 1, ref.getMonth(), ref.getDate() + 1);
  }
  if (hasMin) {
    maxDate = new Date(ref.getFullYear() - minN, ref.getMonth(), ref.getDate());
  }

  if (maxDate > fallbackMax) maxDate = fallbackMax;
  if (minDate > maxDate) minDate = new Date(maxDate);
  return { minDate, maxDate };
}

export function validateAgeForTrekRange({ birthdate, minAge, maxAge, referenceDate }) {
  const minN = minAge != null && minAge !== '' ? Number(minAge) : null;
  const maxN = maxAge != null && maxAge !== '' ? Number(maxAge) : null;
  const hasMin = Number.isFinite(minN);
  const hasMax = Number.isFinite(maxN);
  if (!hasMin && !hasMax) return { ok: true };

  const age = ageYearsOnDate(birthdate, referenceDate);
  if (age == null) {
    return { ok: false, message: 'Enter a valid date of birth.' };
  }

  const rangeLabel = formatTrekAgeRangeLabel(hasMin ? minN : null, hasMax ? maxN : null);
  if (hasMin && age < minN) {
    return {
      ok: false,
      age,
      message: `Age on departure must be within ${rangeLabel}. This traveller would be ${age}.`
    };
  }
  if (hasMax && age > maxN) {
    return {
      ok: false,
      age,
      message: `Age on departure must be within ${rangeLabel}. This traveller would be ${age}.`
    };
  }
  return { ok: true, age };
}
